const PERSIST_INTAKE_SENT = 'persist_intakeSent';
const PERSIST_MEDICAL_RELEASE = 'persist_medicalRelease';
const PERSIST_OFFICE_POLICIES = 'persist_office_policies';
const PERSIST_INFORMED_CONSENT_FOR_TESTING = 'persist_informed_consent_for_testing';
const PERSIST_INFORMED_CONSENT_FOR_VIDEO = 'persist_informed_consent_for_video';
const PERSIST_WELCOME_PACKET = 'persist_welcome_packet';
const PERSIST_BRIEF_BACKGROUND = 'persist_brief_background';
const PERSIST_TREATMENT_PROCESS = 'persist_treatment_process';
const PERSIST_INFORMED_EXPECTATION = 'persist_informed_expectation';
const PERSIST_CREDIT_CARD = 'persist_credit_card';
const PERSIST_HEALTH_INFORMATION = 'persist_health_information';
const PERSIST_CONSENT_FOR_BI = 'persist_consent_for_bi';
const PERSIST_TELEMEDICINE_CONSENT = 'persist_telemedicine_consent';
const PERSIST_ABA_INTAKE = 'persist_aba_intake';
const PERSIST_TREATMENT_INFORMED_CONSENT = 'persist_treatment_informed_consent';
const PERSIST_CHILD_TREATMENT_QUESTIONNAIRE = 'persist_child_treatment_questionnaire';
const PERSIST_NEUROPSYCHOLOGY_PATIENT = 'persist_neuropsychology_patient';
const PERSIST_RELEASE_OF_HEALTH_INFORMATION_PEDIATRICIAN = 'persist_release_of_health_information_pediatrician';
const PERSIST_RELEASE_OF_HEALTH_INFORMATION_SCHOOL = 'persist_release_of_health_information_school';
const PERSIST_CONSENT_TESTING_DOE_CASES = 'persist_consent_testing_doe_cases';
export default {
    PERSIST_INTAKE_SENT,
    PERSIST_MEDICAL_RELEASE,
    PERSIST_OFFICE_POLICIES,
    PERSIST_ABA_INTAKE,
    PERSIST_INFORMED_CONSENT_FOR_TESTING,
    PERSIST_INFORMED_CONSENT_FOR_VIDEO,
    PERSIST_TELEMEDICINE_CONSENT,
    PERSIST_CONSENT_TESTING_DOE_CASES,
    PERSIST_TREATMENT_INFORMED_CONSENT,
    PERSIST_CHILD_TREATMENT_QUESTIONNAIRE,
    PERSIST_NEUROPSYCHOLOGY_PATIENT,
    PERSIST_RELEASE_OF_HEALTH_INFORMATION_PEDIATRICIAN,
    PERSIST_RELEASE_OF_HEALTH_INFORMATION_SCHOOL,
    PERSIST_WELCOME_PACKET,
    PERSIST_BRIEF_BACKGROUND,
    PERSIST_TREATMENT_PROCESS,
    PERSIST_INFORMED_EXPECTATION,
    PERSIST_CREDIT_CARD,
    PERSIST_HEALTH_INFORMATION,
    PERSIST_CONSENT_FOR_BI,
};
